import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JjsvFooter } from './jjsv-footer/jjsv-footer.component';
import { HomePage } from '../pages/home-page/home-page.component';
import { LoginPage } from '../pages/login-page/login-page.component';
import { JjsvHeader } from './jjsv-header/jjsv-header.component';
import { CmsConfig, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        HeaderComponent:{
          component: JjsvHeader,
        },
        FooterComponent: {
          component: JjsvFooter,
        }
      },
    }),
  ],
})
export class ComponentsModule {}
